<script>
export default {
  data() {
    return {
      departmentVisible: false,
      treeData: [],
      callback_fun: null,
      defaultProps: {
        label: 'department_name',
        children: 'children',
      }
    }
  },
  methods:{
    show() {
      this.treeData = []
      this.departmentVisible = true
      // if(typeof callback_fun === "function"){
      //   this.callback_fun = callback_fun;
      // }
    },
    loadNode(node, resolve) {
      const parentId = node.level === 0 ? 0 : node.data.id
      setTimeout(() => {
        this.$myhttp.get('https://flow.gdzawy.com:9001/hr/department/getDepartmentList', {
          params: { parent_id: parentId }
        }).then(resp => {
          let res = resp.data
          if(res.code == 0) {
            const list = res.data || []

            if (list.length === 0) {
              if (node.level > 0 && node.data) {
                node.data.leaf = true
              }
              resolve([])
              return
            }

            const nodes = list.map(item => ({
              id: item.id,
              department_name: item.department_name,
              ancestor_name: item.ancestor_name,
            }))

            resolve(nodes)
          } else {
            resolve([])
          }
        }).catch(() => {
          resolve([])
        })
      }, 300)
    },

    handleNodeClick(data) {
      if(typeof this.callback_fun === "function"){
        this.callback_fun(data);
        this.callback_fun=undefined;
      }
      this.$emit('handleNodeClick', data)
      this.departmentVisible=false;
    },
    handleDialogClose() {
      this.departmentVisible = false
    }
  }
}
</script>

<template>
  <el-dialog
    :visible.sync="departmentVisible"
    title="选择部门"
    append-to-body
    :close-on-click-modal="false"
    @close="handleDialogClose"
    height="80vh"
  >
    <el-tabs type="border-card">
      <el-tab-pane label="组织架构">
        <div style="height: 60vh; overflow-y: auto;">
          <el-tree
            v-if="departmentVisible"
            :data="treeData"
            :props="defaultProps"
            lazy
            :load="loadNode"
            @node-click="handleNodeClick"
            node-key="id"
          >
            <span slot-scope="{ data }">
              <span>{{ data.department_name }}</span>
            </span>
          </el-tree>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/projectCollectionTemplate/HrDepartment.vue